/* Cards & Moor storefront scripts: holo tilt, gallery, variant price, sort, cookie prefs, footer card pile. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  if (!reduce && fine) {
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        el.classList.add('is-tilt');
      });
      el.addEventListener('pointerleave', function () {
        el.style.removeProperty('--rx'); el.style.removeProperty('--ry');
        el.classList.remove('is-tilt');
      });
    });
  }

  var main = document.querySelector('.gal__main img');
  document.querySelectorAll('.gal__thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = b.dataset.src;
      document.querySelectorAll('.gal__thumbs button').forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  var sel = document.querySelector('[data-variant]');
  if (sel) sel.addEventListener('change', function () {
    var o = sel.options[sel.selectedIndex];
    var price = document.querySelector('[data-price]'); if (price) price.textContent = o.dataset.price;
    var url = new URL(location.href); url.searchParams.set('variant', o.value); history.replaceState(null, '', url);
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); location.href = url;
  });

  document.querySelectorAll('[data-cookie-prefs]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); }
      else { location.href = b.dataset.href; }
    });
  });

  var pile = document.querySelector('[data-pile]');
  if (pile) {
    var stage = pile.querySelector('[data-stage]');
    var minis = Array.prototype.slice.call(pile.querySelectorAll('[data-mini]'));
    var W = 0, H = 0, bodies = [], running = false, started = false, grabbed = null, gx = 0, gy = 0, lastT = 0, px = 0, py = 0;
    var measure = function () { W = stage.clientWidth; H = stage.clientHeight; };
    var layoutRest = function () {
      measure();
      bodies = minis.map(function (el, i) {
        var w = el.offsetWidth, h = el.offsetHeight, cols = Math.max(1, Math.floor(W / (w * 0.8)));
        var x = (i % cols) * (W - w) / Math.max(1, cols - 1);
        return { el: el, w: w, h: h, x: x, y: H - h - 10 - Math.floor(i / cols) * 30, vx: 0, vy: 0, a: (i * 37 % 30) - 15, va: 0 };
      });
      draw();
    };
    var drop = function () {
      measure();
      bodies = minis.map(function (el, i) {
        var w = el.offsetWidth, h = el.offsetHeight;
        return { el: el, w: w, h: h, x: Math.random() * (W - w), y: -h - Math.random() * H * 1.4 - i * 25, vx: (Math.random() - .5) * 4, vy: 0, a: (Math.random() - .5) * 60, va: (Math.random() - .5) * 6 };
      });
      if (!running) { running = true; requestAnimationFrame(step); }
    };
    var draw = function () { bodies.forEach(function (b) { b.el.style.transform = 'translate(' + b.x.toFixed(1) + 'px,' + b.y.toFixed(1) + 'px) rotate(' + b.a.toFixed(1) + 'deg)'; }); };
    var step = function () {
      var active = false;
      bodies.forEach(function (b) {
        if (b === grabbed) return;
        b.vy += 0.55; b.x += b.vx; b.y += b.vy; b.a += b.va;
        b.vx *= 0.995; b.va *= 0.98;
        var floor = H - b.h - 6;
        if (b.y > floor) { b.y = floor; b.vy *= -0.32; b.vx *= 0.8; b.va *= 0.6; if (Math.abs(b.vy) < 0.8) b.vy = 0; }
        if (b.x < 0) { b.x = 0; b.vx *= -0.6; }
        if (b.x > W - b.w) { b.x = W - b.w; b.vx *= -0.6; }
        if (Math.abs(b.vx) > 0.05 || Math.abs(b.vy) > 0.05 || b.y < floor - 1) active = true;
      });
      draw();
      if (active || grabbed) requestAnimationFrame(step); else running = false;
    };
    stage.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('[data-mini]'); if (!el) return;
      grabbed = bodies.filter(function (b) { return b.el === el; })[0]; if (!grabbed) return;
      var r = stage.getBoundingClientRect(); gx = e.clientX - r.left - grabbed.x; gy = e.clientY - r.top - grabbed.y;
      px = e.clientX; py = e.clientY; lastT = performance.now();
      el.setPointerCapture(e.pointerId); el.style.zIndex = 5;
      if (!running) { running = true; requestAnimationFrame(step); }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!grabbed) return;
      var r = stage.getBoundingClientRect(), now = performance.now(), dt = Math.max(16, now - lastT);
      grabbed.x = Math.min(Math.max(0, e.clientX - r.left - gx), W - grabbed.w);
      grabbed.y = Math.min(e.clientY - r.top - gy, H - grabbed.h - 6);
      grabbed.vx = (e.clientX - px) / dt * 16; grabbed.vy = (e.clientY - py) / dt * 16; grabbed.va = grabbed.vx * 0.4;
      px = e.clientX; py = e.clientY; lastT = now;
    });
    var release = function () { if (grabbed) { grabbed.el.style.zIndex = ''; grabbed = null; } };
    stage.addEventListener('pointerup', release); stage.addEventListener('pointercancel', release);
    pile.querySelector('[data-shake]').addEventListener('click', function () { if (reduce) { layoutRest(); } else { drop(); } });
    window.addEventListener('resize', function () { if (started) layoutRest(); });
    var start = function () { if (started) return; started = true; if (reduce) layoutRest(); else drop(); };
    if ('IntersectionObserver' in window) {
      layoutRest();
      new IntersectionObserver(function (es, ob) { if (es[0].isIntersecting) { ob.disconnect(); start(); } }, { threshold: 0.35 }).observe(pile);
    } else { start(); }
  }
})();
